import type { App, Project } from '@hangar/shared';
import { useMe } from '@/api/hooks';
import { useStoreApps } from '@/api/endpointsStores';
import { RulesCard } from './RulesCard';
import { StoreAppsCard } from './StoreAppsCard';
import { storesAccessOf } from './storesModel';

/**
 * The app page's Stores tab (P29 phase 1, SPEC §39.4): the Google Play apps builds are submitted to, then the tracks
 * each environment may reach. How each environment submits (track, release status, after each build) lives in its build
 * profile, under the environment.
 */
export function StoresPanel({ app, project }: { app: App; project: Project }) {
  const access = storesAccessOf(useMe().data, app.projectId);
  const storeApps = useStoreApps(app.id);
  const android = (storeApps.data ?? []).filter((s) => s.platform === 'android');
  return (
    <div className="flex flex-col gap-5" data-testid="stores-panel">
      <StoreAppsCard appId={app.id} access={access} />
      {android.length > 0 ? <RulesCard appId={app.id} storeApps={android} environments={project.environments ?? []} access={access} /> : null}
    </div>
  );
}
